const isLocalhost = () => {
  return window.location.hostname === 'localhost'
}

const formatLocalTime = (time: string) => time.toLowerCase().replace(/\s+/g, '')

export const Utils = {
  formatLocalTime,
  isLocalhost,
}
